/**
 * AreaChartEditor
 *
 * Property editor for area chart configuration
 */

import React from 'react';
import { ChartBaseEditor, type ChartBaseConfig } from './ChartBaseEditor';
import { SelectPropertyEditor } from '../../BaseEditors/SelectPropertyEditor';

export interface AreaChartEditorProps {
  config: Partial<ChartBaseConfig & {
    stacking?: 'none' | 'positive';
    interpolation?: 'linear' | 'spline';
    showDots?: boolean;
  }>;
  onChange: (config: Partial<ChartBaseConfig>) => void;
}

export const AreaChartEditor: React.FC<AreaChartEditorProps> = ({ config, onChange }) => {
  return (
    <ChartBaseEditor config={config} onChange={onChange} chartType="Area Chart" showAxes>
      <div className="chart-editor__section">
        <h3 className="chart-editor__section-title">Area Chart Options</h3>

        <SelectPropertyEditor
          label="Stacking"
          value={config.stacking || 'none'}
          onChange={(stacking) => onChange({ ...config, stacking })}
          options={[
            { value: 'none', label: 'None' },
            { value: 'positive', label: 'Stacked' },
          ]}
        />

        <SelectPropertyEditor
          label="Interpolation"
          value={config.interpolation || 'linear'}
          onChange={(interpolation) => onChange({ ...config, interpolation })}
          options={[
            { value: 'linear', label: 'Linear' },
            { value: 'spline', label: 'Spline' },
          ]}
        />

        <div className="chart-editor__checkbox">
          <input
            type="checkbox"
            id="show-dots"
            checked={config.showDots !== false}
            onChange={(e) => onChange({ ...config, showDots: e.target.checked })}
            className="af-property-editor__checkbox"
          />
          <label htmlFor="show-dots">Show Data Points</label>
        </div>
      </div>
    </ChartBaseEditor>
  );
};

AreaChartEditor.displayName = 'AreaChartEditor';
